
import { mapGetters } from "vuex";
import ChevronDownIcon from "~/assets/svg/heroicons/chevron-down.svg?inline=1";
import InventoriesModal from "~/modals/InventoriesModal";

export default {
  components: {
    ChevronDownIcon,
  },
  props: {
    productItem: {
      type: Object,
      required: true,
    },
    productCategory: {
      type: String,
      required: true,
    },
    inventoryTotal: {
      type: Number,
      required: false,
    },
    productName: {
      type: String,
      required: true,
    },
    productSlug: {
      type: String,
      required: true,
    },
    hasIntroduction: {
      type: Boolean,
      default: false,
    },
    hasFaqs: {
      type: Boolean,
      default: false,
    },
    hasGallery: {
      type: Boolean,
      default: false,
    },
    hasTopFeatures: {
      type: Boolean,
      default: false,
    },
    hasSpecifications: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scrolled: 0,
    };
  },
  computed: {
    ...mapGetters({
      hasGeometries: "productmenu/getGeometries",
      hasManuals: "productmenu/getManuals",
    }),
    products() {
      // All, Carbon, etc
      const productsByType = this.$store.state.products.filter(
        (e) => e.name === this.productCategory
      )[0].products;
      return Object.keys(productsByType).flatMap((key) => productsByType[key]);
    },
    scrollItemClass() {
      const locale = this.$store.state.locale;
      if (locale === "es" || locale === "gr") {
        return "text-sm";
      }
      return "text-base";
    },
  },
  beforeMount() {
    if (process.browser) {
      window.addEventListener("scroll", this.handleScroll, false);
    }
  },
  beforeDestroy() {
    if (process.browser) {
      window.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    handleScroll() {
      this.scrolled = window.pageYOffset !== undefined ? window.scrollY : "";
    },
    openTab(tab) {
      const sliderPagination = document.querySelector(".tab__pagination");
      let selectedTab = 0;

      switch (tab) {
        case "geometries":
          selectedTab = 1;
          break;
        case "manuals":
          selectedTab = 2;
          break;
        default:
          selectedTab = 0;
          break;
      }
      sliderPagination.children.item(selectedTab).click();
    },
    openInventoriesModal() {
      this.$modal.show(
        InventoriesModal,
        {
          productSlug: this.productSlug,
        },
        {
          height: "80%",
          maxWidth: 1280,
        }
      );
    },
  },
};
